import React from "react";

type Props = {
  title: string;
  description: string;
  highlightedCounts: string[];
};

const DashboardHero: React.FC<Props> = ({
  title,
  description,
  highlightedCounts,
}) => {
  return (
    <section className="relative overflow-hidden rounded-2xl bg-gradient-to-r from-gray-900 to-gray-700 shadow-xl">
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1587293852726-70cdb56c2866?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1740&q=80')] bg-cover bg-center opacity-10"></div>
      <div className="relative grid gap-6 px-8 py-12 lg:grid-cols-[minmax(0,1.7fr)_minmax(260px,1fr)]">
        <div className="space-y-4 flex flex-col justify-center">
          <span className="inline-flex items-center gap-2 px-0 py-1 text-xs font-bold uppercase tracking-[0.18em] text-white">
            <svg
              className="w-5 h-5 text-white"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 8h2v-2H7v2zm0-4h2v-2H7v2zm0-4h2V7H7v2zm4 8h2v-2h-2v2zm0-4h2v-2h-2v2zm0-4h2V7h-2v2zm4 8h2v-2h-2v2zm0-4h2v-2h-2v2zm0-4h2V7h-2v2z"
              />
            </svg>
            Dashboard Overview
          </span>
          <div className="space-y-2">
            <h2 className="text-3xl font-extrabold text-white lg:text-4xl">
              {title}
            </h2>
            <p className="max-w-2xl text-base leading-7 text-gray-100 lg:text-lg">
              {description}
            </p>
          </div>
        </div>

        <div className="grid gap-3 sm:grid-cols-3 lg:grid-cols-1">
          {highlightedCounts.map((item) => (
            <div
              key={item}
              className="rounded-xl bg-white/10 backdrop-blur-sm border border-white/20 px-4 py-4 shadow-sm flex items-center justify-center transition hover:bg-white/20"
            >
              <p className="text-base font-semibold text-white">{item}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DashboardHero;
